// MOCK FatSecret-style food data + search (demo only — no network).
// Represents the FUTURE FatSecret search behavior: whole/generic foods rank first;
// packaged/branded results appear last (only surfaced when relevant / searched by name).

const s = (unit, size, cal, p, c, f) => ({ unit, size, perUnit: { calories: cal, protein: p, carbs: c, fat: f } });

export const FOODS = [
  // --- sauces / dressings ---
  { record: 'Tzatziki', kind: 'generic', component: 'dressings_or_sauce', servings: [s('tbsp', 1, 15, 0.5, 0.8, 1.2), s('cup', 1, 240, 8, 12, 19)] },
  { record: 'Ranch Dressing', kind: 'generic', component: 'dressings_or_sauce', servings: [s('tbsp', 1, 36, 0.1, 0.5, 3.8)] },
  { record: 'Caesar Dressing', kind: 'generic', component: 'dressings_or_sauce', servings: [s('tbsp', 1, 39, 0.3, 0.5, 4.2)] },
  { record: 'Greek Yogurt Sauce', kind: 'generic', component: 'dressings_or_sauce', servings: [s('tbsp', 1, 9, 0.8, 0.6, 0.4)] },
  { record: 'Hummus', kind: 'generic', component: 'dressings_or_sauce', servings: [s('tbsp', 1, 25, 1.2, 2, 1.4)] },
  { record: 'BBQ Sauce', kind: 'generic', component: 'dressings_or_sauce', servings: [s('tbsp', 1, 29, 0.1, 7, 0.1)] },
  { record: 'Sabra Classic Hummus', kind: 'branded', component: 'dressings_or_sauce', servings: [s('tbsp', 1, 35, 1, 2, 3)] },

  // --- cooking fats ---
  { record: 'Olive Oil', kind: 'generic', component: 'fats_or_rich', servings: [s('tsp', 1, 40, 0, 0, 4.5), s('tbsp', 1, 119, 0, 0, 13.5)] },
  { record: 'Butter', kind: 'generic', component: 'fats_or_rich', servings: [s('tsp', 1, 34, 0, 0, 3.8), s('tbsp', 1, 102, 0.1, 0, 11.5)] },
  { record: 'Coconut Oil', kind: 'generic', component: 'fats_or_rich', servings: [s('tsp', 1, 40, 0, 0, 4.5), s('tbsp', 1, 117, 0, 0, 13.6)] },
  { record: 'Ghee', kind: 'generic', component: 'fats_or_rich', servings: [s('tsp', 1, 45, 0, 0, 5)] },

  // --- whole foods for "add missing" ---
  { record: 'Pita Bread', kind: 'generic', component: 'grains', servings: [s('piece', 1, 165, 5.5, 33, 0.8), s('oz', 1, 78, 2.6, 15.6, 0.4)] },
  { record: 'White Rice', kind: 'generic', component: 'grains', servings: [s('cup, cooked', 1, 205, 4.3, 45, 0.4)] },
  { record: 'Avocado', kind: 'generic', component: 'fats_or_rich', servings: [s('half', 1, 130, 1.6, 7, 12)] },
  { record: 'Boiled Egg', kind: 'generic', component: 'protein', servings: [s('egg', 1, 78, 6.3, 0.6, 5.3)] },
  { record: 'Grilled Chicken Breast', kind: 'generic', component: 'protein', servings: [s('breast', 1, 284, 53, 0, 6)] },
  { record: 'Kalamata Olives', kind: 'generic', component: 'fats_or_rich', servings: [s('olive', 5, 25, 0.2, 1.4, 2.3)] },
  { record: 'Naan (Store-bought)', kind: 'branded', component: 'grains', servings: [s('piece', 1, 260, 9, 48, 3.3)] },
];

// Whole/generic first; then packaged/branded. Optional `prefer` component floats matches up.
export function searchFoods(query, opts = {}) {
  const t = (query || '').toLowerCase().trim();
  const prefer = opts.prefer;
  const matched = FOODS.filter((f) => !t || f.record.toLowerCase().includes(t));
  const scored = matched.map((f) => ({
    f,
    score: (f.kind === 'generic' ? 0 : 10) + (prefer && f.component === prefer ? -1 : 0),
  }));
  scored.sort((a, b) => a.score - b.score);
  return scored.map((x) => x.f).slice(0, 8);
}

export const findFood = (record) => FOODS.find((f) => f.record === record);
